export const PRODUCT_IMAGE_CREATE = "PRODUCT_IMAGE_CREATE";
export const PRODUCT_IMAGE_DELETE = "PRODUCT_IMAGE_DELETE";
export const PRODUCT_UPDATE_POSITION = "PRODUCT_UPDATE_POSITION";
